<template>
    <div v-if="selectedColor" id="pickerPicture" ref="pickerPicture">
        <b-row class="narrow mb-1" :style="pickerPictureStyles">
            <b-col sm="8">
                <div class="pickerPicture"  :style="{backgroundColor:selectedColor.rgb, height:pictureHeight, backgroundImage: pickerPicture}">
                    <b-row style="height:100%;">
                        <b-col class="d-flex flex-column justify-content-center" cols="6">
                            <span class="pointer">
                                <svgicon icon="chevron-left" width="70" height="70" color="#222" @click="prevPicture"></svgicon>
                            </span>
                        </b-col>
                        <b-col class="d-flex flex-column justify-content-center text-right" cols="6">
                            <span class="pointer">
                                <svgicon icon="chevron-right" width="70" height="70" color="#222" @click="nextPicture"></svgicon>
                            </span>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col sm="4">
                <div style="height:100%;transition:all 1s;" class="text-uppercase py-3 px-4" :style="colorStyle">
                    <h6>{{selectedColor.name}}<br /><br /></h6>
                    <div class="addColorContainer">
                        <b-button class="addColorBtn text-uppercase" v-if="selectedColor.base == 'A' && !pageMode" :style="buttonStyle" @click="selectColor()">Tilføj farve</b-button>
                        <br>NB: Farverne kan afvige fra det, du ser på skærmen
                    </div>
                </div>
            </b-col>
        </b-row>     
        <b-row class="allColorsRow" ref="allColorsRow" :style="{maxHeight:colorsHeight}" style="overflow-y:auto;">
            <div v-if="darkColors.length==0 && lightColors.length==0" class="my-4 w-100 text-center">Ingen resultater</div>
            <b-col cols="2" :md="1" class="mb-1" v-for="(color, index) in lightColors" :key="color.index">
                <div @click="selectedColor=color" DISABLEDv-scroll-to="'body'" class="square" :class="{selected:color==selectedColor}" :style="{backgroundColor:color.rgb}"></div>
            </b-col>
            <b-col cols="12" class="py-2 sticky-top" style="background-color:white;" v-if="visBase != 'Base A' && darkColors.length>0"><h5><center>VÆLG MØRKE FARVER (TONES FORLØBIGT KUN I VORES FORRETNINGER)</center></h5></b-col>
            <b-col cols="2" :md="1" class="mb-1" v-for="(color, index) in darkColors" :key="color.index">
                <div @click="selectedColor=color" DISABLEDv-scroll-to="'body'" class="square" :class="{selected:color==selectedColor}" :style="{backgroundColor:color.rgb}"></div>
            </b-col>
        </b-row>       
    </div>
</template>

<script>
import '../../icons/chevron-right'
import '../../icons/chevron-left'
import axios from "axios";
function isBrightColor(color)
{
    // https://trendct.org/2016/01/22/how-to-choose-a-label-color-to-contrast-with-background/
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    var colors = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
    var brightness = (colors.r * 299 + colors.g * 587 + colors.b * 114) / 1000;
    return brightness>123;
}
export default {
    props:["visBase", "tilladBase", "Color", "pageMode", "searchColor"],
    computed:{
        pickerPicture(){
            // background-image: ;
            return 'url("/Dist/img/colorPickerBackground' + this.pickerPictureIndex + '.png")';
        },
        lightColors(){
            return this.colors.filter(c=>c.base == "A" && (!this.searchColor || c.name.toLowerCase().indexOf(this.searchColor.toLowerCase())>=0));
        },
        darkColors(){
            // return [];
            return this.colors.filter(c=>c.base == "C" && (!this.searchColor || c.name.toLowerCase().indexOf(this.searchColor.toLowerCase())>=0));
        },
        colorStyle(){
            return {color: (isBrightColor(this.selectedColor.rgb) ? "black" : "white"), backgroundColor: this.selectedColor.rgb};
        },
        buttonStyle(){
            return {color: (isBrightColor(this.selectedColor.rgb) ? "black" : "white"), borderColor: (isBrightColor(this.selectedColor.rgb) ? "black" : "white")};
        },
        selectedColorIndex:{
            get(){return this.colors.indexOf(this.selectedColor)},
            set(newIndex){
                this.selectedColor = this.colors[newIndex];
            }
        }
    },
    watch:{
        searchColor(newVal){
            
        }
    },
    methods:{
        prevPicture(){
            this.pickerPictureIndex--;
            if(this.pickerPictureIndex==-1)
                this.pickerPictureIndex = 2;
        },
        nextPicture(){
            this.pickerPictureIndex++;
            if(this.pickerPictureIndex==3)
                this.pickerPictureIndex = 0;
        },
        selectColor(){
            this.$emit("selectColor", this.selectedColor);

            // // check for valid colorchoice
            // console.log(this.tilladBase);
            // if(this.tilladBase == "Base A" && this.selectedColor.base == "C" || 
            //    this.tilladBase == "Base C" && this.selectedColor.base == "A"){
            //     this.visFejl = true;
            //     return;
            // } 

            // this.showPicker = false;
            // this.color = this.selectedColor.name
        },
        setHeight(){
            // if(this.$refs.pickerPicture)
            // {
            //     console.log("setHeight", this.$refs.pickerPicture.getBoundingClientRect().top, this.$refs.pickerPicture);
            //     if(this.$refs.pickerPicture.getBoundingClientRect().top<48)
            //         this.pickerPictureStyles = {
            //             position:"fixed",
            //             top: "48px",
            //             zIndex:2000,
            //             backgroundColor:"white",
            //             width:(this.$refs.allColorsRow.getBoundingClientRect().width+6) + "px",
            //             // marginLeft:"-14px"
            //         };
            //     else
            //         this.pickerPictureStyles = null;
            // }
            if(window.innerWidth<768)
            {
                this.colorsHeight = (window.innerHeight - 400) + "px";
                this.pictureHeight = "250px"
            }
            else
            {
                this.colorsHeight = (window.innerHeight - 500) + "px";
                this.pictureHeight = "400px";
            }   
        }
    },
    data(){
        return {
            // color:"Hvid",
            pickerPictureIndex : 0,
            selectedColor : null,
            showPicker : false,
            colors : [],
            colorsHeight: null,
            pictureHeight: null,
            visFejl : false,
            pickerPictureStyles : null
        }
    },
    mounted(){
        axios.get("/Dist/data/colorsAll.json?1").then((res)=>{
            this.colors = res.data;
            var colorIndex = 0;
            this.colors.map(c=>c.index = colorIndex++);
            if(this.visBase == "Base A")
                this.colors = res.data.filter(c=>c.base == "A");
            else if(this.visBase == "Base C")
                this.colors = res.data.filter(c=>c.base == "C");
            this.selectedColor = this.colors[0];
            // this.selectColor();
        });
        this.setHeight();
        window.addEventListener('scroll', this.setHeight);
        window.addEventListener('resize', this.setHeight);
    },
    beforeDestroy() {
        window.addEventListener('scroll', this.setHeight);
        window.removeEventListener('resize', this.setHeight)
    }
}
</script>

<style lang="scss" scoped>
    .root /deep/ {

        .colors{
            margin:0 -0.25rem;
            .color{
                width:66px;
                height:66px;
                margin:2px;
                float:left;
                cursor:pointer;
                &.selected{
                    border:solid 2px black;
                }
            }
        }
        .modal-body{
            padding-top:0;
            padding-bottom:0;
        }
        .modal-lg{
            max-width:1140px;
        }
        .modal-header{
            background-color:white !important;
            color:unset;
            .close{
                color:unset;
            }
        }
    }
    .pickerPicture{
        height:400px;
        background-position-y:bottom;
        background-size:100% auto;
        background-repeat: no-repeat;
        transition: all 0.5s;
    }
    .narrow{
        margin:0 -18px 0 -18px;
        > div
        {
            padding-right:2px;
            padding-left:2px;
        }
    }
    .allColorsRow{
        > div
        {
            padding-right:2px;
            padding-left:2px;
        }
    }
    .square:before{
        content: "";
        display: block;
        padding-top: 100%;  /* initial ratio of 1:1*/
    }
    .square.selected{
        border:solid 2px #333;
    }

    .addColorContainer{
            position: absolute;
            bottom:4px;
            right:20px;
            font-size:12px;
            text-align:right;
        .addColorBtn{
            background-color: transparent;
            border-radius: 0;
            border-width: 2px;
            padding:8px 16px;

            //576
            @media only screen and (max-width: 576px) {
                bottom:8px;
                right:3px;
            }
        }
    }
</style>